import messages from '../../../locale/messages';
import { inputTextLimit, inputDescLimit, containsMalicious, containsMaliciousForEditor } from '../../../helpers/textRestriction';

const validate = values => {

  const errors = {}

  if (!values.content) {
    errors.content = messages.required;
  } else if (values.content && values.content.trim() == '') {
    errors.content = messages.required.defaultMessage;
  } else if (containsMaliciousForEditor(values.content)) {
    errors.content = messages.invalidInput;;
  }

  if (!values.metaTitle) {
    errors.metaTitle = messages.required;
  } else if (values.metaTitle && values.metaTitle.trim() == '') {
    errors.metaTitle = messages.required;
  } else if (values.metaTitle && values.metaTitle.length > inputTextLimit) {
    errors.metaTitle = messages.inputFieldRestriction;
  } else if (containsMalicious(values.metaTitle)) {
    errors.metaTitle = messages.invalidInput;;
  }

  if (!values.metaDescription) {
    errors.metaDescription = messages.required;
  } else if (values.metaDescription && values.metaDescription.trim() == '') {
    errors.metaDescription = messages.required;
  } else if (values.metaDescription && values.metaDescription.length > inputDescLimit) {
    errors.metaDescription = messages.descriptionFieldRestriction;
  } else if (containsMalicious(values.metaDescription)) {
    errors.metaDescription = messages.invalidInput;;
  }

  return errors
}

export default validate